__webpack_require__.p = "https://admind.examanytime.com/";